import { NoDataState } from '@design-system/components/m-not-available';
import { TaxonomyTab } from '../../models/TaxonomyTab';
import { TaxonomyFeature } from '../../models/TaxonomyFeature';

export class CampaignAccordionConstants {
  public static readonly noData = NoDataState.noCampaignMapping;
  public static readonly tabWiseNoDataMessages: Record<
    TaxonomyTab,
    { title: string; description: string }
  > = {
    [TaxonomyTab.unmapped]: {
      title: 'You have approved all necessary campaigns',
      description: 'New campaigns that need mapping will appear here.'
    },
    [TaxonomyTab.mapped]: {
      title: 'No campaigns have been mapped yet.',
      description: 'Check the ‘Unmapped’ tab to map those campaigns, if any.'
    },
    [TaxonomyTab.underProcessing]: {
      title: 'No campaign mappings in progress',
      description: 'Check the ‘Unmapped’ tab to map those campaigns, if any.'
    }
  };

  public static readonly accordionStateByCampaignType: Record<
    TaxonomyTab | TaxonomyFeature.AI,
    {
      requestInProgress: boolean;
      activeAccordionIndex: number | null;
      loading: boolean;
    }
  > = {
    [TaxonomyTab.unmapped]: {
      requestInProgress: false,
      activeAccordionIndex: null,
      loading: false
    },
    [TaxonomyTab.mapped]: {
      requestInProgress: false,
      activeAccordionIndex: null,
      loading: false
    },
    [TaxonomyTab.underProcessing]: {
      requestInProgress: false,
      activeAccordionIndex: null,
      loading: false
    },
    [TaxonomyFeature.AI]: {
      requestInProgress: false,
      activeAccordionIndex: null,
      loading: false
    }
  };
}
